import { render, staticRenderFns } from "./viewPathes.vue?vue&type=template&id=f90f7a74&scoped=true&"
import script from "./viewPathes.vue?vue&type=script&lang=js&"
export * from "./viewPathes.vue?vue&type=script&lang=js&"
import style0 from "./viewPathes.vue?vue&type=style&index=0&id=f90f7a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90f7a74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
